<template>
  <div>
    <div class="d-flex justify-content-end align-items-end">
      <label class="switch mb-3">
        <input type="checkbox" v-model="isUjian" @change="handleModeChange" />
        <span class="slider round">
          <span class="switch-text left">Latihan</span>
          <span class="switch-text right">Ujian</span>
        </span>
      </label>
    </div>

    <div v-if="isLoading" class="container-fluid">
      <loading-vue style="padding: 5%;"></loading-vue>
    </div>

    <template v-else>
      <template v-if="setError">
        <div class="my-5 text-center">
          <p class="fs-3">
            <strong>{{ setError }} Silahkan hubungi admin.</strong>
          </p>
        </div>
      </template>

      <template v-else-if="setScore.length === 0">
        <div class="my-5 text-center">
          <p><strong>Tidak ada grafik saat ini.</strong></p>
        </div>
      </template>

      <template v-else>
        <div
          class="table-responsive"
          v-for="(score, index) in setScore"
          :key="index"
        >
          <table class="table table-bordered">
            <thead>
              <tr class="bg-secondary">
                <th colspan="13">
                  <span class="text-white text-uppercase">{{
                    score.package.name
                  }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <resilience-chart :data="score.grafik" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import loadingVue from "@/components/loading.vue";
import axios from "axios";
import ResilienceChart from "@/components/charts/ResilienceChart.vue";

export default {
  components: { loadingVue, ResilienceChart },
  page: {
    title: "Nilai Ujian",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Nilai Ujian",
      items: [
        { text: "Dashboard", href: "/" },
        { text: "Nilai", active: true },
      ],
      isLoading: true,
      // Prefer exam data, but getScore() falls back to the other mode when
      // the selected mode has no graph (for example, a student with only
      // Latihan Sikap Kerja data).
      isUjian: true,
      setError: null,
      setScore: [],
      dataLatihan: [],
      dataValue: null,
      vert: null,
      listHasilUjian: [],
      listHasilUjianAkademik: [],
      listPaketSoal: [],
      detailSoal: [
        { paket: "Test Kecerdasan" },
        { paket: "Test Kepribadian" },
        { paket: "Test Sikap Kerja" },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getScore();
  },
  methods: {
    async getScore() {
      this.isLoading = true;
      this.setError = null;
      try {
        const selectedMode = this.isUjian ? 1 : 0;
        let response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/api/get-scores/resilience-graph`,
          {
            params: {
              is_ujian: selectedMode,
            },
          }
        );

        let scores = Array.isArray(response.data) ? response.data : [];

        // A student may have only Latihan or only Ujian results. Avoid a
        // misleading empty state by checking the other mode once and syncing
        // the toggle with the mode that actually returned data.
        if (scores.length === 0) {
          const fallbackMode = selectedMode === 1 ? 0 : 1;
          response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/api/get-scores/resilience-graph`,
            {
              params: {
                is_ujian: fallbackMode,
              },
            }
          );

          const fallbackScores = Array.isArray(response.data)
            ? response.data
            : [];
          if (fallbackScores.length > 0) {
            scores = fallbackScores;
            this.isUjian = fallbackMode === 1;
          }
        }

        this.setScore = scores;
      } catch (error) {
        console.log(error);
        const message = error.response && error.response.data
          ? error.response.data.error
          : "Grafik tidak dapat dimuat";
        this.setError = message;
        this.$store.commit("setError", message);
      } finally {
        this.isLoading = false;
      }
    },
    handleModeChange() {
      this.getScore(); // Reload data when mode changes
    },
  },
  middleware: "authentication",
};
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 90px;
  height: 30px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
  z-index: 2;
}

.switch-text {
  position: absolute;
  color: white;
  font-size: 12px;
  font-weight: 500;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.4s;
}

.switch-text.left {
  left: 35px;
  opacity: 1;
}

.switch-text.right {
  right: 40px;
  opacity: 0;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(60px);
}

input:checked + .slider .switch-text.left {
  opacity: 0;
}

input:checked + .slider .switch-text.right {
  opacity: 1;
}
</style>
